import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
} from "@mui/material";

import AccessKeyAddCard from "../Forms/AccessKeyAddCard";

export default function AddModal({accessKeys, setAccessKeys, refresh, setRefresh, setErr}) {
    const [open, setOpen] = useState(false);
  
    const handleClickOpen = () => {
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);
    };
  
    return (
      <div style={{width: 100, paddingTop: 10}}>
        <Button
        size="large" variant="contained" color="primary" onClick={handleClickOpen}>
          Add
        </Button>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
          >
          <DialogContent>
          <AccessKeyAddCard accessKeys={accessKeys} setAccessKeys={setAccessKeys} setOpen={setOpen} refresh={refresh} setRefresh={setRefresh} setErr={setErr}/>
          </DialogContent>
        </Dialog>
      </div>
    );
  }